import React, { useState, useEffect } from 'react';
import validate from 'validate.js';
import { Translate, I18n } from "react-redux-i18n";

const schema = {
    name: {
        presence: { allowEmpty: false, message: 'is required' },
        length: {
            maximum: 100
        }
    },
}

const FormDialog = (props) => {

    const [dialogState, setDialogState] = useState({
        values: {
            name: "",
            id: props.user_id,
        },
        errors: {},
        touched: {},
        isValid: false,
    });


    useEffect(() => {
        const errors = validate(dialogState.values, schema);
        setDialogState(dialogState => ({
            ...dialogState,
            isValid: errors ? false : true,
            errors: errors || {}
        }));
    }, [dialogState.values]);

    return (
            <div className='dialog' onClose={props.handleClose}>
                <div className='dialog-content'>
                    <div className='dialog-title'> Name List</div>
               
                    <div className='dialog-content-text'>
                        Enter Name List
                    </div>
                    <input
                        className='input'
                        autoFocus
                        margin="dense"
                        id="name"
                        name="name"
                        required
                        label="Name"
                        type="text"
                        onChange={props.handleChange}
                        fullWidth
                        value={props.name}
                        variant="standard"
                    />
                    <div className='dialog-actions'>
                        <button 
                            className='btn btn-secondary'
                            onClick={props.handleClose}
                        >  
                            <Translate value="cancel" />
                        </button>
                        <button 
                            className='btn btn-primary' 
                            onClick={props.handleSave}
                            disabled={props.isValid}
                        >
                            <Translate value="save" />
                        </button>
                    </div>
                </div>
            </div>
        
    );
}

export default FormDialog;

/**
 *  <Button variant="text" onClick={handleClickOpen}>
                Add List
            </Button>
 */
